import { atom } from 'jotai';
import { z } from 'zod';
import {
  LineGraphEntry,
  pCompanyPieChartGraphEntry,
} from '~/api/def/endpoints/fundAnalyticsEndpoint';
import { FundGetData } from '~/api/def/endpoints/fundEndpoint';

interface FundAnalyticsState {
  pieChartDate: (pCompanyPieChartGraphEntry & { fill: string })[];
  grossIRRData: (LineGraphEntry & { fill: string })[];
  grossMOICData: (LineGraphEntry & { fill: string })[];
  fundNames: string[];
  loading: boolean;
  error: Error | null;
}

export const fundAnalyticsDataAtom = atom<FundAnalyticsState>({
  pieChartDate: [],
  grossIRRData: [],
  grossMOICData: [],
  fundNames: [],
  loading: false,
  error: null,
});

interface FundListState {
  fundList: FundGetData[];
  loading: boolean;
  error: Error | null;
}

export const fundAnalyticsListAtom = atom<FundListState>({
  fundList: [],
  loading: false,
  error: null,
});

export const selectedFundAtom = atom<FundGetData | null>(null);

export const STATIC_WIDGET_IDS = [
  'companies-per-sector',
  'invested-per-sector',
  'aggr-gross-moic',
  'aggr-gross-irr',
  'fund-list',
  'ems-blotter',
  'historical-returns',
  'forward-returns',
  'recommendation-report',
] as const;

const widgetIdSchema = z.enum(STATIC_WIDGET_IDS);

export type WidgetId = z.infer<typeof widgetIdSchema>;

export const widgetGenerationRequestSchema = z.object({
  id: widgetIdSchema,
});

export type WidgetGenerationRequest = z.infer<
  typeof widgetGenerationRequestSchema
>;

const widgetActionSchema = z.enum(['add', 'remove']);

export type WidgetAction = z.infer<typeof widgetActionSchema>;

const widgetOperationSchema = z.object({
  action: widgetActionSchema,
  widgets: z.array(widgetGenerationRequestSchema).optional(),
});

export type WidgetOperation = z.infer<typeof widgetOperationSchema>;

export const widgetOperationAtom = atom<WidgetOperation | null>(null);
